const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSHlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "112px",
    height: "206px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 36.8333,-0.5 74.1667,-0.5 111.5,-0.5C 111.5,68.1667 111.5,136.833 111.5,205.5C 74.1667,205.5 36.8333,205.5 -0.5,205.5C -0.5,136.833 -0.5,68.1667 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0af05",
    d: "M 31.5,115.5 C 20.0743,103.822 15.741,89.8222 18.5,73.5C 27.8047,56.2278 37.6381,39.2278 48,22.5C 48.4828,21.552 48.6495,20.552 48.5,19.5C 58.3726,23.4371 67.7059,28.4371 76.5,34.5C 63.9108,55.75 51.4108,77.0834 39,98.5C 36.0086,103.983 33.5086,109.65 31.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#70821f",
    d: "M 96.5,94.5 C 91.4892,88.1617 85.4892,82.8284 78.5,78.5C 77.8313,80.6309 77.1646,82.6309 76.5,84.5C 76.6657,80.1539 76.499,75.8206 76,71.5C 75.2935,69.9194 74.4601,68.4194 73.5,67C 85.464,72.3478 93.1307,81.5145 96.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899d05",
    d: "M 18.5,73.5 C 15.741,89.8222 20.0743,103.822 31.5,115.5C 30.284,118.871 29.284,122.205 28.5,125.5C 17.0702,118.322 10.4035,107.989 8.5,94.5C 10.524,86.7886 13.8573,79.7886 18.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c8c05",
    d: "M 96.5,94.5 C 99.0476,102.179 99.0476,109.846 96.5,117.5C 94.1741,104.525 87.5074,94.5246 76.5,87.5C 76.5,86.5 76.5,85.5 76.5,84.5C 77.1646,82.6309 77.8313,80.6309 78.5,78.5C 85.4892,82.8284 91.4892,88.1617 96.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889d03",
    d: "M 76.5,87.5 C 87.5074,94.5246 94.1741,104.525 96.5,117.5C 94.7541,125.651 91.4208,132.985 86.5,139.5C 89.259,123.178 84.9257,109.178 73.5,97.5C 74.248,94.0954 75.248,90.7621 76.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c8c05",
    d: "M 8.5,94.5 C 10.4035,107.989 17.0702,118.322 28.5,125.5C 28.5,126.833 28.5,128.167 28.5,129.5C 27.8365,131.042 27.1698,132.709 26.5,134.5C 19.8965,130.23 13.8965,125.23 8.5,119.5C 5.9404,111.021 5.9404,102.688 8.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0af05",
    d: "M 73.5,97.5 C 84.9257,109.178 89.259,123.178 86.5,139.5C 76.2772,157.452 65.9439,175.285 55.5,193C 54.5,193.667 53.5,193.667 52.5,193C 44.3339,188.418 36.3339,183.585 28.5,178.5C 41.5328,156.63 54.3662,134.63 67,112.5C 69.4573,107.629 71.624,102.629 73.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#708220",
    d: "M 8.5,119.5 C 13.8965,125.23 19.8965,130.23 26.5,134.5C 27.1698,132.709 27.8365,131.042 28.5,129.5C 27.8608,135.352 28.8608,140.852 31.5,146C 19.8841,140.866 12.2175,132.033 8.5,119.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSHlogo);
export default __webpack_public_path__ + "static/media/SHlogo.0a913aba418943e3ddf14197fbfb21a6.svg";
export { ForwardRef as ReactComponent };